export default "__VITE_ASSET__de799722__"